import vendorService from "../../../../services/procurementService/vendorService";
import { CACHE_KEY_VENDORS } from "../../../../utils/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VendorInterface } from "../../../../models/ProcurementModule/Vendor";

interface DeleteVendorContext {
  previousVendors: VendorInterface[];
  deletedVendor: VendorInterface | undefined;
}

const useDeleteVendor = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the customer to delete
    DeleteVendorContext
  >({
    mutationFn: vendorService.Remove, // Remove should take a string ID

    onMutate: (vendorId: string) => {
      const previousVendors =
        queryClient.getQueryData<VendorInterface[]>([
          CACHE_KEY_VENDORS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<VendorInterface[]>(
        [CACHE_KEY_VENDORS, page, pageSize],
        previousVendors.filter((vendor) => vendor.id !== vendorId) // Use statusId to filter
      );

      return {
        previousVendors,
        deletedVendor: previousVendors.find((vendor) => vendor.id === vendorId),
      };
    },

    onError: (error, vendorId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<VendorInterface[]>(
        [CACHE_KEY_VENDORS, page, pageSize],
        context.previousVendors
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteVendor;
